import {createAction} from '@reduxjs/toolkit';

import {
  BasketCalculation,
  BasketItemInput,
  GetMetaDataPayload,
  IBasketQuantityChangedProductMap,
  ItemToUpdateQuantity,
  PromoAdvice,
  PromotionPayload,
  RemovePromotionVoucherPayload,
  UpdateMetaDataPayload
} from 'types';
import {BasketVoucherDetails, FetchBasketVouchersQuery} from 'types/campaign';

export const setBasketDetailsAction = createAction<any>('SET_BASKET_DETAILS');
export const setIsLoadingAction = createAction<boolean>('SET_IS_LOADING');
export const getBasketCalculationAction = createAction<BasketCalculation | undefined>('GET_BASKET_CALCULATION');
export const updatePreviewItemQuantityAction = createAction<any>('UPDATE_PREVIEW_ITEM_QUANTITY');
export const setIsBasketApiFailedAction = createAction<boolean>('SET_IS_BASKET_API_FAILED');
export const removeUnavailableItemsAction = createAction<any>('REMOVE_UNAVAILABLE_ITEMS');
export const removePromotionVoucherAction = createAction<RemovePromotionVoucherPayload>('REMOVE_PROMOTION_VOUCHER');
export const setSelected1PSectionsAction = createAction<any>('SET_SELECTED_1P_SECTION');
export const setSelectedItemsAction = createAction<string[]>('SET_SELECTED_ITEMS');
export const deleteSelectedItemsAction = createAction('DELETE_SELECTED_ITEMS');
export const getBasketPromotionsLiteAction = createAction('GET_BASKET_PROMOTIONS_LITE');
export const getRM3PromotionsAction = createAction<PromotionPayload>('GET_RM3_PROMOTIONS');
export const setRM3PromotionsAction =
  createAction<Record<string, {promoAdvice: PromoAdvice[]; loading: boolean}>>('SET_RM3_PROMOTIONS');
export const setBasketPromotionsLiteAction = createAction<any>('SET_BASKET_PROMOTIONS_LITE');
export const setBasketPromotionsLiteLoadingAction = createAction<boolean>('SET_BASKET_PROMOTIONS_LITE_LOADING');
export const batchUpdateItemsQuantityAction = createAction<ItemToUpdateQuantity[]>('BATCH_UPDATE_ITEMS_QUANTITY');
export const setVariantIdsOfItemThatWasAdjustedQuantityAction = createAction<string[]>(
  'SET_VARIANT_IDS_OF_ITEM_THAT_WAS_ADJUSTED_QUANTITY'
);
export const setBasketQuantityChangedProductMapAction = createAction<IBasketQuantityChangedProductMap>(
  'SET_BASKET_QUANTITY_CHANGE_PRODUCT_MAP'
);
export const bulkUpdateBasketItemsPreviewAction = createAction<BasketItemInput[]>('BULK_UPDATE_BASKET_ITEMS');
export const getBasketRecommendationsAction = createAction('GET_BASKET_RECOMMENDATIONS');
export const setBasketRecommendationsAction = createAction<any>('SET_BASKET_RECOMMENDATIONS');
export const setIsBasketRecommendationLoadingAction = createAction<boolean>('SET_IS_BASKET_RECOMMENDATION_LOADING');
export const updateMetaDataAction = createAction<UpdateMetaDataPayload>('UPDATE_META_DATA');
export const getMetaDataAction = createAction<GetMetaDataPayload | undefined>('GET_META_DATA');
export const setRecommendationsComplexPromotionAction =
  createAction<Record<string, {promoAdvice: PromoAdvice[]; loading: boolean}>>('SET_COMPLEX_PROMOTION');
export const fetchBasketVouchersAction = createAction<FetchBasketVouchersQuery>('FETCH_BASKET_VOUCHERS');

export const setBasketVouchersAction = createAction<BasketVoucherDetails | undefined>('SET_BASKET_VOUCHERS');
export const selectItemIdsAction = createAction<string[]>('SELECT_ITEM_IDS');
export const unselectItemIdsAction = createAction<string[]>('UNSELECT_ITEM_IDS');
export const checkedUnselectItemIdsAction = createAction<string[]>('CHECKED_UNSELECT_ITEM_IDS');
